// extracted by mini-css-extract-plugin
export var actionButton = "_cx-0";
export var attachmentLine = "_cx-1";
export var fileInput = "_cx-2";
export var fileUploadWrapper = "_cx-4";
export var footer = "_cx-3";
export var modalContent = "_cx-5";
export var paperclip = "_cx-6";
export var quillEditor = "_cx-7";